import { createContext } from 'react';

const OEContext = createContext({});

export default OEContext;
